import React from 'react'

type DialogBodyProps = {
  title: string
  text: string
}

const CommonDialogBody: React.FC<DialogBodyProps> = ({title, text}) => {
  return (
    <div className='d-flex flex-column justify-content-center align-items-center flex-gap-8'>
      <video
        className='exclamation'
        src='/media/exclamation.mp4'
        autoPlay
        loop
        muted
        playsInline
        poster='/media/exclamation.gif'
      />
      <div className='d-flex flex-column justify-content-center align-items-center flex-gap-4'>
        <span className='font-size-20 line-height-28 font-weight-semibold text-black'>{title}</span>
        <span className='font-size-12 line-height-20 font-weight-regular text-silver-gray'>
          {text}
        </span>
      </div>
    </div>
  )
}

export default CommonDialogBody
